import { plmApp } from "../app";
import { ResourceAppModule } from "@/shared/app";
import { Produkt, produktResource } from "@megarax/client/src/resources/plm";

export const produktModule: ResourceAppModule = {
  formComponent: () => import("./ItemForm.vue"),
  sheetComponent: () => import("./ItemSheet.vue"),
  listComponent: () => import("./ItemList.vue"),
  iconClass: "fas fa-flask fa-fw",
  app: plmApp,
  title: "Produkty",
  route: "produkt",
  itemConstructor: Produkt,
  resource: produktResource,
};
